import type { TriviaClue } from '../services/triviaClues';

type Difficulty = NonNullable<TriviaClue['difficulty']>;

const LEVELS: Difficulty[] = ['easy', 'medium', 'hard'];

export interface DifficultyBreakdown {
  easy: number;
  medium: number;
  hard: number;
  counted: number;
}

export function difficultyBreakdown(clues: Array<Pick<TriviaClue, 'difficulty'>>): DifficultyBreakdown | null {
  const counts: Record<Difficulty, number> = { easy: 0, medium: 0, hard: 0 };
  for (const clue of clues) {
    if (clue.difficulty && LEVELS.includes(clue.difficulty)) counts[clue.difficulty] += 1;
  }
  const counted = counts.easy + counts.medium + counts.hard;
  if (counted === 0) return null;

  const percents: Record<Difficulty, number> = { easy: 0, medium: 0, hard: 0 };
  for (const level of LEVELS) percents[level] = Math.floor((counts[level] * 100) / counted);

  const leftover = 100 - (percents.easy + percents.medium + percents.hard);
  const byLargestRemainder = [...LEVELS].sort(
    (a, b) => ((counts[b] * 100) % counted) - ((counts[a] * 100) % counted),
  );
  for (const level of byLargestRemainder.slice(0, leftover)) percents[level] += 1;

  return { ...percents, counted };
}

export function formatDifficultyBreakdown(breakdown: DifficultyBreakdown): string {
  return `easy ${breakdown.easy}% / med ${breakdown.medium}% / hard ${breakdown.hard}%`;
}
